/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState, useCallback, forwardRef } from 'react'
import { createPortal } from 'react-dom'
import s from './CreatePopup.module.css'

const CreatePopup = forwardRef(({ onClose, fetchCollections }, ref) => {
  const [inProgress, setInProgress] = useState(false)
  const [collectionName, setCollectionName] = useState('')
  const [collectionNote, setCollectionNote] = useState('')

  const handleCreateCollection = useCallback(async () => {
    try {
      setInProgress(true)
      const apiToken = localStorage.getItem('apiToken')

      const response = await fetch(`/api/v3/listing_collections`, {
        headers: {
          'API_TOKEN': apiToken,
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
        method: 'POST',
        body: JSON.stringify({ name: collectionName, description: collectionNote }),
      })

      const data = await response.json()
      console.log(data)
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error)
    } finally {
      fetchCollections()
      setInProgress(false)
      onClose()
    }
  }, [collectionName, collectionNote, onClose, fetchCollections])

  return createPortal(
    <div ref={ref}>
      <div className={s.overlay} />
      <div className={s.root}>
        <div className={s.title}>Create Collection</div>

        <label className={s.label} htmlFor="name">
          Collection Name
        </label>
        <input
          className={s.input}
          type="text"
          id="name"
          value={collectionName}
          placeholder="Best Brooklyn's Apartments"
          onChange={(e) => {
            const { value } = e.target
            setCollectionName(value)
          }}
        />

        <label className={s.label} htmlFor="note">
          Notes <span className={s.optional}>(optional)</span>
        </label>
        <textarea
          name="note"
          className={s.textarea}
          rows={4}
          value={collectionNote}
          placeholder="Hey client name these are the best apartments in Brooklyn."
          onChange={(e) => {
            const { value } = e.target
            setCollectionNote(value)
          }}
        />

        <div className={s.controls}>
          <button type="button" className={s.create} disabled={inProgress} onClick={handleCreateCollection}>
            Save
          </button>

          <button type="button" className={s.close} onClick={onClose}>
            Close
          </button>
        </div>

        <svg
          className={s.closeIcon}
          xmlns="http://www.w3.org/2000/svg"
          width="28"
          height="28"
          viewBox="0 0 28 28"
          fill="none"
          onClick={() => onClose()}
        >
          <path
            d="M22.4946 21.2564C22.5758 21.3377 22.6403 21.4342 22.6843 21.5405C22.7283 21.6467 22.751 21.7605 22.751 21.8755C22.751 21.9905 22.7283 22.1043 22.6843 22.2105C22.6403 22.3167 22.5758 22.4133 22.4946 22.4946C22.4133 22.5758 22.3167 22.6403 22.2105 22.6843C22.1043 22.7283 21.9905 22.751 21.8755 22.751C21.7605 22.751 21.6467 22.7283 21.5405 22.6843C21.4342 22.6403 21.3377 22.5758 21.2564 22.4946L14.0005 15.2375L6.74455 22.4946C6.58036 22.6587 6.35768 22.751 6.12549 22.751C5.89329 22.751 5.67061 22.6587 5.50642 22.4946C5.34224 22.3304 5.25 22.1077 5.25 21.8755C5.25 21.6433 5.34224 21.4206 5.50642 21.2564L12.7635 14.0005L5.50642 6.74455C5.34224 6.58036 5.25 6.35768 5.25 6.12549C5.25 5.89329 5.34224 5.67061 5.50642 5.50642C5.67061 5.34224 5.89329 5.25 6.12549 5.25C6.35768 5.25 6.58036 5.34224 6.74455 5.50642L14.0005 12.7635L21.2564 5.50642C21.4206 5.34224 21.6433 5.25 21.8755 5.25C22.1077 5.25 22.3304 5.34224 22.4946 5.50642C22.6587 5.67061 22.751 5.89329 22.751 6.12549C22.751 6.35768 22.6587 6.58036 22.4946 6.74455L15.2375 14.0005L22.4946 21.2564Z"
            fill="currentColor"
          />
        </svg>
      </div>
    </div>,
    document.body
  )
})

CreatePopup.displayName = 'CreatePopup'

export default CreatePopup
